import React, { useState, useCallback, useMemo } from 'react';
import { AsyncSelectPaginate } from 'src/shared/ui/components/async-select-paginate';
import { allParticipants } from '../../queries';
import { ADD_PARTICIPANT_OPTIONS, generateOptionsList } from '../helpers';

const addNewParticipantOption = {
  createNew: true,
  data: null,
  label: 'Add New Participant',
  value: 'add-new-participant',
};

const generateAllParticipantOption = (participant) => {
  const account = participant?.account;
  return {
    data: participant,
    id: participant?.id,
    label: `${participant.firstName} ${participant.lastName} ${
      account?.id ? `(${account.fullName} , ${account.email})` : ''
    }`,
    value: participant?.id,
  };
};

const SelectParticipant = ({ setParticipant, franchiseId }) => {
  const [inputValue, setInputValue] = useState('');
  const [addParticipant, setAddParticipant] = useState(
    ADD_PARTICIPANT_OPTIONS.existing.value,
  );

  const handleParticipantTypeChange = useCallback(
    (value) => {
      const addParticipantValue = value?.createNew
        ? ADD_PARTICIPANT_OPTIONS.new.value
        : ADD_PARTICIPANT_OPTIONS.existing.value;
      if (value && addParticipantValue !== addParticipant) {
        setAddParticipant(addParticipantValue);
      }
    },
    [addParticipant],
  );

  const handleParticipantChange = useCallback(
    (value) => {
      setParticipant(value);
      handleParticipantTypeChange(value);
    },
    [setParticipant, handleParticipantTypeChange],
  );

  const memoizedDefaultOptions = useMemo(() => {
    const newParticipantOption = inputValue
      ? {
          label: inputValue,
          value: inputValue,
        }
      : {};
    return inputValue
      ? [{ ...addNewParticipantOption, ...newParticipantOption }]
      : [];
  }, [inputValue]);

  return (
    <div className="mb-16">
      <div className="label-text">
        Select or Create a Participant{' '}
        <span className="tw-text-red tw-ml-1 fs-13 fw-500">*</span>
      </div>
      <AsyncSelectPaginate
        placeholder="Select a participant"
        dataKey="allParticipants"
        defaultOptions={memoizedDefaultOptions}
        getOptionsFromResults={(results) =>
          generateOptionsList(results, generateAllParticipantOption)
        }
        inputValue={inputValue}
        onChange={handleParticipantChange}
        onInputChange={setInputValue}
        query={allParticipants}
        searchKey="search"
        franchiseId={franchiseId}
      />
    </div>
  );
};

export default React.memo(SelectParticipant);
